import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { RuntimeProfileService } from '../services/RuntimeProfileService';

// En-tete du mode contournement, a garder aligne sur JwtTokenMiddleware et helpers/api.ts.
export const AUTH_BYPASS_HEADER = 'X-Matwins-Debug-Bypass';

// Signale a l'API le profil "local" ; pose uniquement sur les appels a notre API.
@Injectable()
export class AuthBypassInterceptor implements HttpInterceptor {
  private runtimeProfile = inject(RuntimeProfileService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.runtimeProfile.skipsAuthentication) return next.handle(req);

    const apiUrl = environment.apiBaseUrl;
    if (!apiUrl || !req.url.startsWith(apiUrl)) return next.handle(req);

    return next.handle(req.clone({ setHeaders: { [AUTH_BYPASS_HEADER]: 'true' } }));
  }
}
